// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const PG_REQUEST_PAGE_DATA = 'PG_REQUEST_PAGE_DATA';
const PG_REQUEST_PAGE_DATA_SUCCESS = 'PG_REQUEST_PAGE_DATA_SUCCESS';

export {
  PG_REQUEST_PAGE_DATA,
  PG_REQUEST_PAGE_DATA_SUCCESS,
};
